import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material.module';
import { IconModule } from './icon.module';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeResourceUrlPipe } from './pipes/safe-resource-url.pipe';
import { CodeDirective } from './directives/code.directive';
import { DisableScrollDirective } from './directives/disable-scroll.directive';
import { LazyImgDirective } from './directives/lazy-image.directive';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { FocusDirective } from './directives/focus.directive';
import { AlertComponent } from './components/alert/alert.component';
import { AlreadyActiveMessageComponent } from './components/already-active-message/already-active-message.component';
import { ArticleItemComponent } from './components/article-item/article-item.component';
import { ContentBlockedComponent } from './components/content-blocked/content-blocked.component';
import { FeaturedImageComponent } from './components/featured-image/featured-image.component';
import { HeaderImageComponent } from './components/header-image/header-image.component';
import { HighlightedVideoSliderComponent } from './components/highlighted-video-slider/highlighted-video-slider.component';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { LoaderComponent } from './components/loader/loader-component';
import { PaymentNotificationDialogComponent } from './components/payment-notification-dialog/payment-notification-dialog.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SerieItemComponent } from './components/serie/serie-item.component';
import { SnackbarUnlockComponent } from './components/snackbar-unlock/snackbar-unlock.component';
import { VideoItemComponent } from './components/video-item/video-item.component';
import { VideoSliderComponent } from './components/video-slider/video-slider.component';

const COMPONENTS = [
	AlertComponent,
	AlreadyActiveMessageComponent,
	ArticleItemComponent,
	ContentBlockedComponent,
	FeaturedImageComponent,
	HeaderImageComponent,
	HighlightedVideoSliderComponent,
	ImageCropperComponent,
	LoaderComponent,
	PaymentNotificationDialogComponent,
	SearchInputComponent,
	SerieItemComponent,
	SnackbarUnlockComponent,
	VideoItemComponent,
	VideoSliderComponent,
];

const PIPES = [SafeHtmlPipe, SafeResourceUrlPipe];

const DIRECTIVES = [
	CodeDirective,
	DisableScrollDirective,
	FocusDirective,
	LazyImgDirective,
	StopPropagationDirective,
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		IconModule,
		TranslateModule,
		...COMPONENTS,
		...PIPES,
		...DIRECTIVES,
	],
	declarations: [],
	exports: [
		FormsModule,
		IconModule,
		MaterialModule,
		ReactiveFormsModule,
		TranslateModule,
		...COMPONENTS,
		...PIPES,
		...DIRECTIVES,
	],
	providers: [],
})
export class SharedModule { }
